import React, { useRef, useState } from "react";
import { useUserMedia } from "./useUserMedia";
import { Button } from "react-bootstrap";
import Header from "./Header";

export interface IImageCapture {
    onClose: () => void,
    savePhoto: (base64str: string) => void
}

const ImageCapture: React.FC<IImageCapture> = (props) => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const canvasRef = useRef<HTMLCanvasElement>(null);
    let mediaStream = useUserMedia();

    const [isReady, setIsReady] = useState(false);

    const [isVideoPlaying, setIsVideoPlaying] = useState(true);
    // const [isBusy, setIsBusy] = useState(false);

    if (mediaStream && videoRef.current && !videoRef.current.srcObject) {
        videoRef.current.srcObject = mediaStream;
    };

    const handleCanPlay = () => {
        videoRef.current?.play();
        setIsReady(true);
    };

    const handleClear = () => {
        const context = canvasRef.current!.getContext("2d");
        context?.clearRect(0, 0, canvasRef.current!.width, canvasRef.current!.height);
        setIsVideoPlaying(true);
    };

    const handleOnClose = () => {
        handleClear();

        mediaStream?.getTracks().forEach(track => {
                            track.stop();
                            track.enabled = false;
                        })

        setIsVideoPlaying(false);
        mediaStream = null;
        videoRef.current!.srcObject = null;

        props.onClose();
    };

    const captureImage = () => {
        const width =  800;
        const height = videoRef.current!.videoHeight / videoRef.current!.videoWidth * width;

        canvasRef.current!.width = width;
        canvasRef.current!.height = height;

        const context = canvasRef.current!.getContext("2d");
        // context?.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
        context?.drawImage(videoRef.current!, 0, 0, width, height);

        canvasRef.current!.toBlob(async blob => {
            const base64str = await blobToBase64(blob!) as string;
            console.log("base64str", base64str);
            props.savePhoto(base64str);
            handleOnClose(); 
        });

        setIsVideoPlaying(false);
    };

    const blobToBase64 = (blob: Blob) => {
        if(!blob){
            return null;
        }
        return new Promise((resolve, _) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            if(reader.result){                
                const data = reader.result as string;
                resolve(data.substring(data.indexOf(',') + 1));
            } else {
                throw new Error("Error in image capture.");
            }
          }

          reader.readAsDataURL(blob);
        });
    };

    const handleCapture = async () => {
        // setIsBusy(true);
        captureImage();
        // setIsBusy(false);
    }

    return (
        <div  className="data-capture-container">
            <Header title="TAKE A PHOTO OF DOCUMENT"/>
            <div style={{border:"0 dotted darkgrey",  textAlign:"center", width:"100%", height:"500px", marginTop:"5rem"}}>
                <video 
                    ref={videoRef} 
                    onCanPlay={handleCanPlay} 
                    autoPlay 
                    playsInline 
                    muted 
                    // style={{height:"200px"}} 
                    width="100%"
                    height="100%"
                    hidden={!isVideoPlaying}
                    />
            </div>

            <div className="text-center mt-3 flex-sm-column ">
                <Button className="me-sm-2 mb-4 mb-md-2" onClick={handleCapture} disabled={!isReady}>TAKE PHOTO</Button>   
                <Button className="mb-2" onClick={handleOnClose} disabled={!isReady}>BACK</Button>   
            </div>

            <canvas ref={canvasRef} style={{display: "none"}}></canvas>

            {/* {isBusy && <Spinner />} */}
        </div> 
    );
};

export default ImageCapture;